module.exports = __webpack_public_path__ + "media/yìp òk maa yìp òk maa.5c28d322.mp3";